if(!customElements.get('range-slider')) {
    class RangeSlider extends HTMLElement {
        constructor() {
            super();

            this.values = this.querySelector('input[data-real-values]')
            this.from = this.querySelector('[data-from-input]');
            this.from_label = this.querySelector('[data-from-label]');
            this.to = this.querySelector('[data-to-input]');
            this.to_label = this.querySelector('[data-to-label]');
            this.range = this.querySelector('[data-range]');
            this.min = parseInt(this.range.getAttribute('data-min'));
            this.max = parseInt(this.range.getAttribute('data-max'));
                
            if(!this.range) return;

            let _values, 
                _real_values;

            if(this.values){
                _values = this.values.getAttribute('data-values').split(';');
                _real_values = this.values.getAttribute('data-real-values').split(';');
            }

            this.range.addEventListener('input', () => {
                const val = this.range.value.split(',');
                this.from.value = val[0];
                this.to.value = val[1];
                this.from_label.innerText = `${this.formatMoney(val[0])}`;
                this.to_label.innerText = `${this.formatMoney(val[1])}`;

                if(this.values){
                    const start = _values.indexOf(val[0]);
                    const end = _values.indexOf(val[1]) + 1;
                    this.values.value = _real_values.slice(start, end).join(';');
                } 
            });

            this.setOptions();

            this.slider = new rSlider(this.options);

            if(this.values){
                this.values.addEventListener('reset', () => {
                    this.reset();
                });
            } else {
                this.from.addEventListener('reset', () => {
                    this.reset();
                });
            }

            if(this.from){
                this.from.addEventListener('input', () => {
                    if(parseInt(this.from.value) < 0){
                        this.from.value = 0;
                        this.from_label.innerText = `${this.formatMoney(this.min)}`;
                    }
                    this.slider.setValues(parseInt(this.from.value), parseInt(this.to.value), false);
                });
            }
 
            if(this.to){
                this.to.addEventListener('input', () => {
                    if(parseInt(this.to.value) > this.max){
                        this.to.value = this.max;
                    } 
                    this.slider.setValues(parseInt(this.from.value), parseInt(this.to.value), false);
                });
            }
        }

        setOptions() {
            this.options = {
                target: this.range,
                range: true,
                tooltip: false,
                scale: false,
                labels: false,
                set: [],
                values: {
                    min: 0,
                    max: 0
                },
                onChange: vals => {
                    const val = vals.split(',');

                    if(parseInt(val[0]) == this.min && parseInt(val[1]) == this.max){
                        if(this.values){
                            this.values.value = '';
                        } else {
                            this.from.value = '';
                            this.to.value = '';
                            this.from_label.innerText = `${this.formatMoney(this.min)}`;
                            this.to_label.innerText = `${this.formatMoney(this.max)}`;
                        }
                    }

                    this.from.dispatchEvent(new Event('change'));
                    this.to.dispatchEvent(new Event('change'));

                    if(this.values){
                        this.values.dispatchEvent(new Event('change'));
                    }
                }
            }

            if(this.values){ 
                const data = [];
                this.values.getAttribute('data-values').split(';').forEach(value => data.push(parseInt(value)));
                this.options.values = data;

                if(this.values.getAttribute('data-active-values')){
                    const active_values = this.values.getAttribute('data-active-values').split(';');
                    this.options.set.push(parseInt(active_values[0]));
                    this.options.set.push(parseInt(active_values[active_values.length - 1]));
                }
            } else {
                this.options.values.min = this.min;
                this.options.values.max = this.max;
                this.options.step = 1;
                if(this.from.value){ 
                    this.options.set.push(parseInt(this.from.value));
                }
                if(this.to.value){
                    this.options.set.push(parseInt(this.to.value));
                }
            }
        }

        reset() {
            this.slider.destroy();

            this.from.value = '';
            this.to.value = '';
            this.from_label.innerText = `${this.formatMoney(this.min)}`;
            this.to_label.innerText = `${this.formatMoney(this.max)}`;

            if(this.values){
                this.values.value = '';
                this.values.removeAttribute('data-active-values');
            }

            this.setOptions();
            this.slider = new rSlider(this.options);
        }

        formatMoney(amount){
            if (typeof amount == 'string') { amount = amount.replace('.',''); }
            var value = '';
            var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            var formatString = window.locales.money_format;
            amount *= 100;
    
            function defaultOption(opt, def) {
                return (typeof opt == 'undefined' ? def : opt);
            }
    
            function formatWithDelimiters(number, precision, thousands, decimal) {
                precision = defaultOption(precision, 2);
                thousands = defaultOption(thousands, ',');
                decimal   = defaultOption(decimal, '.');
    
                if (isNaN(number) || number == null) { return 0; }
    
                number = (number/100.0).toFixed(precision);
    
                var parts   = number.split('.'),
                    dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                    amount   = parts[1] ? (decimal + parts[1]) : '';
    
                return dollars + amount;
            }
    
            switch(formatString.match(placeholderRegex)[1]) {
                case 'amount':
                value = formatWithDelimiters(amount, 2);
                break;
                case 'amount_no_decimals':
                value = formatWithDelimiters(amount, 0);
                break;
                case 'amount_with_comma_separator':
                value = formatWithDelimiters(amount, 2, '.', ',');
                break;
                case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(amount, 0, '.', ',');
                break;
            }
    
            return formatString.replace(placeholderRegex, value);
        }
    }

    customElements.define('range-slider', RangeSlider);
}
 